export const FEE_GET_FEELIST = "fee/get-fee-list";
